import axios from 'axios';
import { downloadExcel, downloadFile } from '../utils/files';
import {
  IEditMonitorization,
  INewMonitorization
} from '../utils/interfaces/interfaces';
import {
  principal_measuresAPI,
  principal_monitorizationsAPI,
  principal_raportsAPI
} from './routes';

const getMonitorization = async (id: number) =>
  await axios.get(principal_monitorizationsAPI.BY_ID(id));

const downloadMonitorization = async (id: number, name: string) => {
  await axios
    .get(principal_monitorizationsAPI.DOWNLOAD(id), { responseType: 'blob' })
    .then(({ data }) => {
      downloadFile(data, name);
    });
};

const addMonitorization = async (decision: INewMonitorization) =>
  await axios.post(principal_monitorizationsAPI.ADD, { ...decision });

const updateMonitorization = async (decision: IEditMonitorization) =>
  await axios.put(principal_monitorizationsAPI.ADD, { ...decision });

const getAll = async () => await axios.get(principal_monitorizationsAPI.ALL);

/* monitorization documents */
const getMonitorizationDocuments = async (id: number) =>
  await axios.get(principal_monitorizationsAPI.ALL_DOCUMENTS(id));

/* monitorization reports */
const getMonitorizationReports = () =>
  axios.get(principal_raportsAPI.GET_DECISION_RAPORTS);

/* download raport per tabel */
const downloadRaport = async (monitorizationId: number, name: string) => {
  await axios
    .get(principal_measuresAPI.DOWNLOAD_RAPORT_GLOBAL(monitorizationId, name), {
      responseType: 'blob'
    })
    .then(({ data }) => {
      downloadExcel(data, `Raport - ${name}`);
    });
};

const getInstitutionsMonitorizations = async () =>
  await axios.get(principal_monitorizationsAPI.GET_SUBORDERED_MONITORIZATIONS);

export {
  getMonitorization,
  downloadMonitorization,
  addMonitorization,
  updateMonitorization,
  getAll,
  getMonitorizationReports,
  getMonitorizationDocuments,
  downloadRaport,
  getInstitutionsMonitorizations
};
